import {
  CREATE_CAMPAIGN_RULE,
  CREATE_CAMPAIGN_RULE_SUCCESS,
  CREATE_CAMPAIGN_RULE_ERROR,
  CREATE_CAMPAIGN_RULE_EMPTY,
} from './../../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateCampaignRule = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CAMPAIGN_RULE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_RULE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_RULE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_CAMPAIGN_RULE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateCampaignRule;
